import { useWithDelay } from '../../../../hooks/useWithDelay';
import { useDropdownContext } from '../../../DropdownProvider';
import {
  CLOSE_MY_NERDWALLET_MENU_ACTION,
  type MyNerdWalletMenuDeviceType,
  OPEN_MY_NERDWALLET_MENU_ACTION,
} from '../../../DropdownProvider/useSingleDropdown';

export function useMyNerdWalletHoverEventCallbacks() {
  const { state, dispatch } = useDropdownContext();
  const [withDelay, handleCancelMenuClose] = useWithDelay();

  const handleOpenMenu = withDelay((deviceType: MyNerdWalletMenuDeviceType) => {
    if (state.isNotificationSidebarOpen) return;
    dispatch(OPEN_MY_NERDWALLET_MENU_ACTION(deviceType));
  });

  const handleCloseMenu = withDelay(() => {
    dispatch(CLOSE_MY_NERDWALLET_MENU_ACTION);
  });

  return {
    handleOpenMenu,
    handleCloseMenu,
    handleCancelMenuClose,
  };
}
